import React, { useState, useEffect, useRef } from "react";
import Button from "../Button";

const OtpComponent = ({
                          otpLength = 4,
                          timerDuration = 120,
                          validateLoading,
                          description,
                          generateLoading,
                          errorMessage,
                          onGenerateOtp,
                          onValidateOtp,
                      }) => {
    const [otp, setOtp] = useState(Array(otpLength).fill(""));
    const [timer, setTimer] = useState(timerDuration);
    const [isTimerComplete, setIsTimerComplete] = useState(false);
    const [error, setError] = useState("");
    const inputRefs = useRef([]);
    const timerInterval = useRef(null);

    useEffect(() => {
        startTimer();
        return () => clearInterval(timerInterval.current);
    }, []);

    const startTimer = () => {
        setIsTimerComplete(false);
        setTimer(timerDuration);
        clearInterval(timerInterval.current);
        timerInterval.current = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(timerInterval.current);
                    setIsTimerComplete(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const handleGenerateOtp = () => {
        onGenerateOtp(); // Generate OTP (from parent or server)
        setOtp(Array(otpLength).fill("")); // Reset input fields
        startTimer();
    };

    const handleInputChange = (index, value) => {
        if (/^\d$/.test(value)) {
            const updatedOtp = [...otp];
            updatedOtp[index] = value;
            setOtp(updatedOtp);
            if (index < otpLength - 1) {
                inputRefs.current[index + 1]?.focus();
            }
        }
    };

    const handleBackspace = (index) => {
        if (otp[index] === "") {
            if (index > 0) {
                inputRefs.current[index - 1]?.focus();
            }
        } else {
            const updatedOtp = [...otp];
            updatedOtp[index] = ""; // Clear the current input
            setOtp(updatedOtp);
        }
    };

    const handleRetry = () => {
        handleGenerateOtp();
        setError("");
    };

    const handleSubmit = () => {
        const enteredOtp = otp.join("");
        if (enteredOtp.length !== otpLength) {
            setError("لطفا کد اعتبار سنجی را وارد کنید.");
            return;
        }
        onValidateOtp(enteredOtp);
    };

    return (
        <div className="w-11/12 md:max-w-md mx-auto bg-white shadow-sm mt-16 rounded-lg p-4">
            <h2 className="text-lg font-bold text-center mb-1">
                کد اعتبار سنجی را وارد کنید.
            </h2>
            <p className="text-sm text-center mb-2">{description}</p>
            <div className="flex flex-row-reverse justify-center gap-2 mb-4">
                {otp.map((digit, index) => (
                    <input
                        key={index}
                        ref={(ref) => (inputRefs.current[index] = ref)}
                        type="tel"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleInputChange(index, e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Backspace") handleBackspace(index);
                        }}
                        className="w-12 h-12 text-center border border-gray-300 rounded-md text-xl focus:ring-2 focus:ring-green-500 outline-none"
                    />
                ))}
            </div>
            {errorMessage && <p className="text-red-500 text-sm mb-2">{errorMessage}</p>}
            <div className="grid grid-cols-2 gap-2">
                <Button
                    loading={generateLoading}
                    onClick={handleRetry}
                    disabled={!isTimerComplete}
                    theme="link"
                    className="text-sm"
                >
                    {isTimerComplete ? "درخواست مجدد" : ` زمان باقی مانده ${timer}`}
                </Button>
                <Button
                    loading={validateLoading}
                    onClick={handleSubmit}
                    disabled={isTimerComplete}
                    rounded="rounded-lg"
                    theme="green"
                    className="text-sm w-full"
                >
                    مرحله بعد
                </Button>
            </div>
        </div>
    );
};

export default OtpComponent;
